import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import QueryForm from '../../../Pages/Static/queryForm';
import AlorBanner from '../../../../Assets/images/Alor.png';
import AlorBannerMobile from '../../../../Assets/images/Alor.png';
import { isMobileOnly } from 'react-device-detect';

const Alor = () => {
  return (
    <>
      <div className="watch_repaire_services_page">
        <Container fluid>
          <Row>
            <Col sm={12} md={12} lg={12} className="p-0">
              <div>{isMobileOnly ? <Image src={AlorBannerMobile} className="img-fluid"  alt='Oris' /> : 
              <Image src={AlorBanner} className="img-fluid"  alt='Oris'  />}</div>
            </Col>
          </Row>
          {/* </Container>
        <Container> */}
          <div className="text-center pt-5">
            <Row className="justify-content-center">
              <Col lg={8}>
                <h3 className="text-center text-uppercase">Alor</h3>
                <p>
                  Indulge in the allure of Alor, where each jewelry piece is a testament to the brand's commitment to craftsmanship and luxury. Meticulously designed, Alor seamlessly blends contemporary elegance with timeless allure, creating accessories that resonate with sophistication and individuality. Whether adorned with diamonds or crafted from exquisite metals, Alor's jewelry captures the
                  essence of refined beauty, making a distinctive statement for those who appreciate the finer things in life. Elevate your personal style with Alor, where every piece tells a story of enduring craftsmanship and unparalleled sophistication.
                </p>
              </Col>
            </Row>
          </div>
        </Container>
        <QueryForm />
      </div>
    </>
  );
};

export default Alor;
